module.exports = __webpack_public_path__ + "images/5b60e71883bfecab5cb2ca9220acbd99.jpg";